<img *ngIf="image" mat-card-avatar [ngClass]="classes" [src]="source" alt="">
<span *ngIf="placeholder" class="badge" mat-card-avatar [ngClass]="classes" [class.border]="T_ONE_USER"
    [style.background-color]="avatarColor(fan.name)">
    <div>{{ buildNameBackground(fan.name) }}</div>
</span>